/**
 * Created by ChrisMuto on 7/13/17.
 */

export const ADD_NOTIFICATION = "ADD_NOTIFICATION";
export const REMOVE_NOTIFICATION = "REMOVE_NOTIFICATION";



// WEBPACK FOOTER //
// ./src/modules/notifications/types.js